import PropTypes from 'prop-types'
import React from 'react'
import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg';
import Projects from "./Projects";
import Blog from "./blog";
import Art from "./art.js"
// import CustomChatbot from './CustomChatbot';
import { DiReact } from "react-icons/di";
import { DiJavascript1 } from "react-icons/di";
import { DiRuby } from "react-icons/di";
import { DiRor } from "react-icons/di";
import { DiRasberryPi } from "react-icons/di";
import { DiGithubBadge } from "react-icons/di";
// import { DiGithubBadge } from "react-icons/di";
import { DiCss3Full } from "react-icons/di";

import { DiHtml5 } from "react-icons/di";
// import { DiGithubBadge } from "react-icons/di";
// import { DiCss3Full } from "react-icons/di";

// import Devicon from 'devicon-react';
// import IconReact from 'react-devicon/react/original-watermark';
// import IconAmazonwebservices from 'react-devicon/amazonwebservices/original'


class Main extends React.Component {

  // constructor(props) {
  //   super(props);
  //   this.submitForm = this.submitForm.bind(this);
  //   this.state = {
  //     status: ""
  //   };
  // }

  state = {
    status: ""
  }

  submitForm = (ev) => {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }


  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      ></div>
    )

    
    

    return (
      <div
        ref={this.props.setWrapperRef}
        id="main"
        style={this.props.timeout ? { display: 'flex' } : { display: 'none' }}
      >
        {/* <IconReact /> */}
        <article
          id="intro"
          className={`${this.props.article === 'intro' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Intro</h2>

          {/* <FaBeer /> */}
          <DiReact style={{"width":"70", "height":"70"}}/>
          <DiJavascript1 style={{"width":"70", "height":"70"}}/>
          <DiRuby style={{"width":"70", "height":"70"}}/>
          <DiRor style={{"width":"70", "height":"70"}}/>
          <DiRasberryPi style={{"width":"70", "height":"70"}}/>
          <DiGithubBadge style={{"width":"70", "height":"70"}}/>
          <DiCss3Full style={{"width":"70", "height":"70"}}/>

          <i class="devicon-ruby-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-rails-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-react-original-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-javascript-plain colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-html5-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-css3-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          <i class="devicon-postgresql-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"4px"}}></i>
          <i class="devicon-github-plain-wordmark colored" style={{"font-size":"3rem", "margin-right":"3px"}}></i>
          {/* <div>
          <IconAmazonwebservices width={100} height={100}/>
          </div> */}
          {/* <IconReact style={{"width":"100", "height":"100"}}/> */}
          {/* <Devicon name="react" logoStyle="original"/> */}

          {/* <img src="https://i7.pngguru.com/preview/452/495/745/react-javascript-angularjs-ionic-github.jpg"/> */}
          {/* <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="react" class="svg-inline--fa fa-react fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"></path></svg> */}
          <p style={{"font-size":"18px"}}>
          Full-Stack Web Developer with a qualification in public health and medicine. 
          I have experience in application of core principles of public health in psychology and behavioral health. 
          I have also conducted behavioral & medical research in individuals undergoing chemotherapy, underserved populations and those affected by the 9/11 attacks.
          My affinity for technology and its application in solving functional challenges drove me to learn programming. 
          Being fascinated by the prospects of fast growing technology, I wish to contribute as a creative catalyst for making a positive impact in tech enterprise.
          </p>
       
          {close}
        </article>

        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
          >
          <h2 className="major">PROJECTS</h2>
          <span className="image main">
            {/* <img src={pic02} alt="" /> */}
          </span>
          {close}
          <Projects/>
        </article>

        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Art</h2>
          {/* <span className="image main">
            <img src={pic03} alt="" />
          </span> */}
          <Art/>
          {close}
        </article>

        <article
          id="contact"
          className={`${this.props.article === 'contact' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Contact</h2>
          <form 
          method="POST" action="https://formspree.io/mrgkkzjq"
          onSubmit={this.submitForm}
          >
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text"  name="name" id="name" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email"   id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="2"></textarea>
            </div>
            <ul className="actions">
              <li>
                <input type="submit" value="Send Message" className="special" />
              </li>
              <li>
                <input type="reset" value="Reset" />
              </li>
            </ul>
            {this.state.status === "SUCCESS" ? <p>Thanks!</p> : null}
            {this.state.status === "ERROR" && <p>Ooops! There was an error.</p>}
            <input type="text" name="_gotcha" style={{"display":"none"}} />
          </form>
          <ul className="icons">
           
            <li>
              <a 
              target="_blank"
              href="https://www.linkedin.com/in/ransing/" className="icon fa-linkedin fa-lg">
                <span className="label">Linkedin</span>
              </a>
            </li>
            <li>
              <a 
              target="_blank"
              href="ttps://www.instagram.com/ceaselessnyc/" className="icon fa-instagram fa-lg">
                <span className="label">Instagram</span>
              </a>
            </li>
            <li>
              <a
              target="_blank"
                href="https://github.com/ransing"
                className="icon fa-github fa-lg"
              >
                <span className="label">GitHub</span>
              </a>
            </li>
            <li>
              <a
              target="_blank"
                href="https://medium.com/@ransing"
                className="icon fa-medium fa-lg"
              >
                <span className="label">GitHub</span>
              </a>
            </li>
            <p style={{"font-size":"24px", "margin-top":"20px"}}> </p>
          </ul>
          {close}
        </article>

        <article
          id="blog"
          className={`${this.props.article === 'blog' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
        <h2 className="major">Blog</h2>
         <Blog/>
         {close}
        </article>

        
      </div>
    )
  }

  
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
